import { Link } from '@tanstack/react-router';
import { User } from 'iconoir-react';
import { useAuth } from '../../contexts/AuthContext';

export const AccountLink = () => {
  const { currentUser } = useAuth();

  return (
    <div className="ml-4">
      <Link to={`../../../${currentUser?.uid}/account/accountInfo`}>
        <User />
      </Link>
    </div>
  );
};
